import FormValidation from './modules/FormValidation';
import Action from './modules/Action';

new FormValidation().render();

const $body = $('body');

// Клик
$body.on('click', '[data-click]', (event) => {
  event.preventDefault();

  const $this = $(event.currentTarget);
  const data = $this.data('click');

  new Action(data, event.currentTarget);

  return false;
});

$('.js-slider').each((index, element) => {
  const $element = $(element);
  const data = $element.data('slider');

  $(element).slick(data);
});

$('.js-mask--phone').mask('+7 (999)999-99-99');
